/**
 * 顶部TopNav包装组件
 */
import React, { PureComponent } from 'react';
import styles from './TipsiconHoc.module.scss';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';

const cursorSty = {
    cursor: 'not-allowed',
    color: '#d9d9d9'
};

const TipsiconHOC = (WrappedComponent = null) => {
    return class Tipsicon extends PureComponent {
        state = {
            translate: 0, //位移距离
            counter: 1, // 当前翻页计数标识,默认1
            screenNum: 1, //分屏个数
            disabledLeft: true,//左
            disabledRight: false,//右
            keyNum: null,
        }

        componentDidMount() {
            this.setState({
                screenNum: this.splitScreenNum(),
                keyNum: Math.random(),
            });
            window.addEventListener('resize', () => {
                this.setState({
                    screenNum: this.splitScreenNum(),
                    counter: 1,
                    translate: 0,
                    keyNum: Math.random(),
                });
            }); // 监听窗口变化，重置分屏个数
        }

        componentWillUnmount() {
            window.removeEventListener('resize', () => {
                this.setState({
                    screenNum: this.splitScreenNum(),
                    counter: 1,
                    translate: 0,
                });
            });//卸载
        }

        componentDidUpdate(prevProps, prevState) {
            if (this.state.counter !== prevState.counter) {
                this._direction();
            }
            let num = this.splitScreenNum();
            if (this.state.screenNum !== num) {
                this.setState({ screenNum: num });
            }
        }

        //左右图片禁用显示
        _direction = () => {
            const { screenNum, counter } = this.state;
            if (counter === 1) {
                this.setState({
                    disabledLeft: true,
                    disabledRight: false
                });
                return;
            }
            if (counter === screenNum) {
                this.setState({
                    disabledRight: true,
                    disabledLeft: false,
                });
                return;
            }
            this.setState({
                disabledRight: false,
                disabledLeft: false,
            });
        }

        //返回分屏个数
        splitScreenNum = () => {
            let num = undefined;
            if (this.tipsdivWidth() >= this.tipsulWidth()) {
                num = 1;
            } else {
                let d = this.tipsulWidth() % this.tipsdivWidth();//取余
                let init = parseInt(this.tipsulWidth() / this.tipsdivWidth());//取整数部分
                let morethan = d == 0 ? 0 : 1;
                num = init + morethan;
            }
            return num;
        }

        leftHandle = () => {//向左滚动
            const { translate, } = this.state;
            if (this.state.counter === 1) {
                // message.warning('不能左滑了');
                return;
            }
            let saveCounter = this.state.counter - 1;
            let numCount = translate + this.tipsdivWidth();
            this.setState({
                translate: numCount,
                counter: saveCounter,
            });
        }

        rightHandle = () => {//向右滚动
            const { translate, } = this.state;
            if (this.state.counter >= this.state.screenNum) {
                // message.warning('到底了');
                return;
            }
            let saveCounter = this.state.counter + 1;
            let numCount = translate - this.tipsdivWidth();
            this.setState({
                translate: numCount,
                counter: saveCounter,
            });

        }

        //位移距离
        translateHandle = (translate) => {
            return {
                Transform: `translate(${translate}px)`,
                MozTransform: `translate(${translate}px)`,
                WebkitTransform: `translate(${translate}px)`,
                OTransform: `translate(${translate}px)`,
            };
        }

        //tipsdiv宽度 
        tipsdivWidth = () => {
            if (!this.tipsdiv) return;
            let { width } = this.tipsdiv.getBoundingClientRect();
            return width;
        }

        //tipsul宽度
        tipsulWidth = () => {
            if (!this.tipsul) return;
            let { width } = this.tipsul.getBoundingClientRect();
            return width;
        }

        render() {
            const { translate, screenNum, disabledLeft, disabledRight, keyNum } = this.state;
            return (
                <div key={keyNum} className={styles.tipsContainer}>
                    <div
                        ref={(tipsdiv) => { this.tipsdiv = tipsdiv; }}
                        className={styles.tipsdiv}
                        style={{ width: screenNum === 1 ? '100%' : 'calc(100% - 90px)' }}
                    >
                        <div className={styles.divul} style={this.translateHandle(translate)} ref={(tipsul) => { this.tipsul = tipsul; }}>
                            <WrappedComponent {...this.props}></WrappedComponent>
                        </div>
                    </div>
                    {screenNum > 1 && <LeftCircleOutlined style={disabledLeft ? cursorSty : null} onClick={() => this.leftHandle()} className={styles.leftCircle} />}
                    {screenNum > 1 && <RightCircleOutlined style={disabledRight ? cursorSty : null} onClick={() => this.rightHandle()} className={styles.rightCircle} />}
                </div >
            );
        }
    };
};

export default TipsiconHOC;